@if (showDesignToggle && screenWidth > 1024) {
<div class="selector-design-toggle d-flex align-items-center gap-2 mb-2">
  <span class="selector-design-toggle-label fs-11 fw-semibold">Design</span>
  <div class="selector-design-toggle-group d-flex gap-1" role="group" aria-label="Selector design variant">
    <button type="button" class="selector-design-toggle-btn fs-12 fw-semibold"
      [class.selector-design-toggle-btn--active]="selectorDesignVariant === 'legacy'"
      (click)="setSelectorDesignVariant('legacy')">
      Previous
    </button>
    <button type="button" class="selector-design-toggle-btn fs-12 fw-semibold"
      [class.selector-design-toggle-btn--active]="selectorDesignVariant === 'pill'"
      (click)="setSelectorDesignVariant('pill')">
      Reference
    </button>
  </div>
</div>
}

<!-- Desktop only: pill / legacy design variants -->
@if (screenWidth > 1024) {
@if (selectorDesignVariant === 'pill') {
<div id="st-mobile-participant-category-selector-selectionarea-pill"
  class="selection_area d-flex gap-2 align-items-center flex-nowrap">
  <div id="st-mobile-participant-category-selector-block-pill" *ngIf="hasParticipantOptions">
    <div id="st-mobile-participant-category-selector-st-login-dropdown-pill" class="st-selector-dropdown first">
      <mat-select id="st-mobile-participant-category-selector-block-1-pill" panelClass="selector-panel-pill"
        [(value)]="active_participant_id" (selectionChange)="handleParticipantChange($event.value)"
        [disabled]="disable_participant_selection">
        @for (option of displayParticipantList; track option ? option.id : $index) {
        <mat-option [id]="'st-mobile-participant-category-selector-block-2-pill' + (option.id)" [value]="option?.id">{{
          (option?.title || '') | translate }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
  <div id="st-mobile-participant-category-selector-block-3-pill" *ngIf="shouldShowCategoryDropdown">
    <div id="st-mobile-participant-category-selector-st-login-dropdown-4-pill" class="st-selector-dropdown second">
      <mat-select id="st-mobile-participant-category-selector-block-5-pill" panelClass="selector-panel-pill"
        [value]="categoryDropdownValue" (selectionChange)="handleCategorySelection($event.value)">
        @for (option of displayCategoryList; track option ? (option.video_type || option.category_id) : $index) {
        <mat-option [id]="'st-mobile-participant-category-selector-block-6-pill' + (option.id)"
          [value]="option?.video_type || option?.category_id">{{ option | categoryDisplayLabel }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
  <div id="st-mobile-participant-category-selector-block-7-pill"
    *ngIf="internalShowSubCategories && hasSubCategoryOptions">
    <div id="st-mobile-participant-category-selector-st-login-dropdown-8-pill"
      class="st-selector-dropdown sub-category stage-dropdown">
      <mat-select id="st-mobile-participant-category-selector-block-9-pill" panelClass="selector-panel-pill"
        [(value)]="active_category_id" (selectionChange)="handleSubCategorySelection($event.value)">
        @for (option of internalSubCategories; track option ? (option.video_type || option.category_id) : $index) {
        <mat-option [id]="'st-mobile-participant-category-selector-block-10-pill' + (option.id)"
          [value]="option?.video_type || option?.category_id">{{ option | categoryDisplayLabel }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
  <div id="st-mobile-participant-category-selector-block-11-pill" *ngIf="shouldShowStageDropdown">
    <div id="st-mobile-participant-category-selector-st-login-dropdown-12-pill" class="st-selector-dropdown second">
      <mat-select id="st-mobile-participant-category-selector-block-13-pill" panelClass="selector-panel-pill"
        [(value)]="active_stage" (selectionChange)="handleStageSelection($event.value)">
        @for (option of stage_list; track option ? option : $index) {
        <mat-option [id]="'st-mobile-participant-category-selector-block-14-pill' + (option.id)" [value]="option">{{
          getLocalizedStageName(option?.name) }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
</div>
} @else {
<div id="st-mobile-participant-category-selector-selectionarea"
  class="selection_area d-flex gap-2 align-items-center flex-nowrap">
  <div id="st-mobile-participant-category-selector-block" *ngIf="hasParticipantOptions">
    <div id="st-mobile-participant-category-selector-st-login-dropdown" class="st-selector-dropdown first">
      <mat-select id="st-mobile-participant-category-selector-block-1" class=" " panelClass="selector-panel-legacy"
        [(value)]="active_participant_id" (selectionChange)="handleParticipantChange($event.value)"
        [disabled]="disable_participant_selection">
        @for (option of displayParticipantList; track option ? option.id : $index) {
        <mat-option [id]="'st-mobile-participant-category-selector-block-2' + (option.id)" [value]="option?.id">{{
          (option?.title || '') | translate }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
  <div id="st-mobile-participant-category-selector-block-3" *ngIf="shouldShowCategoryDropdown">
    <div id="st-mobile-participant-category-selector-st-login-dropdown-4" class="st-selector-dropdown second">
      <mat-select id="st-mobile-participant-category-selector-block-5" class=" " panelClass="selector-panel-legacy"
        [value]="categoryDropdownValue" (selectionChange)="handleCategorySelection($event.value)">
        @for (option of displayCategoryList; track option ? (option.video_type || option.category_id) : $index) {
        <mat-option [id]="'st-mobile-participant-category-selector-block-6' + (option.id)"
          [value]="option?.video_type || option?.category_id">{{ option | categoryDisplayLabel }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
  <div id="st-mobile-participant-category-selector-block-7" *ngIf="internalShowSubCategories && hasSubCategoryOptions">
    <div id="st-mobile-participant-category-selector-st-login-dropdown-8"
      class="st-selector-dropdown sub-category stage-dropdown">
      <mat-select id="st-mobile-participant-category-selector-block-9" class=" " panelClass="selector-panel-legacy"
        [(value)]="active_category_id" (selectionChange)="handleSubCategorySelection($event.value)">
        @for (option of internalSubCategories; track option ? (option.video_type || option.category_id) : $index) {
        <mat-option [id]="'st-mobile-participant-category-selector-block-10' + (option.id)"
          [value]="option?.video_type || option?.category_id">{{ option | categoryDisplayLabel }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
  <div id="st-mobile-participant-category-selector-block-11" *ngIf="shouldShowStageDropdown">
    <div id="st-mobile-participant-category-selector-st-login-dropdown-12" class="st-selector-dropdown second">
      <mat-select id="st-mobile-participant-category-selector-block-13" class=" " panelClass="selector-panel-legacy"
        [(value)]="active_stage" (selectionChange)="handleStageSelection($event.value)">
        @for (option of stage_list; track option ? option : $index) {
        <mat-option [id]="'st-mobile-participant-category-selector-block-14' + (option.id)" [value]="option">{{
          getLocalizedStageName(option?.name) }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
</div>
}
}

<!-- Mobile: original production UI (unaffected by desktop design variants) -->
@if (screenWidth <= 1024) { <div id="st-mobile-participant-category-selector-selectionarea-15"
  class="selection_area d-flex flex-wrap align-items-center gap-2">
  <div id="st-mobile-participant-category-selector-block-16" class="w-100 selector-cell" *ngIf="hasParticipantOptions">
    <div id="st-mobile-participant-category-selector-st-login-dropdown-17" class="st-selector-dropdown first">
      <button type="button" class="d-flex align-items-center gap-2 selector-trigger mobile-selector-trigger"
        [disabled]="disable_participant_selection" (click)="openDrawer('participant')">
        <span class="selector-trigger-text">{{ participantTriggerLabel }}</span>
        <svg class="selector-trigger-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
          viewBox="0 0 20 20" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.21995 8.22C5.36058 8.07955 5.5512 8.00066 5.74995 8.00066C5.9487 8.00066 6.13933 8.07955 6.27995 8.22L9.99995 11.94L13.72 8.22C13.7886 8.14631 13.8714 8.08721 13.9634 8.04622C14.0554 8.00523 14.1547 7.98319 14.2554 7.98141C14.3561 7.97963 14.4562 7.99816 14.5495 8.03588C14.6429 8.0736 14.7278 8.12974 14.799 8.20096C14.8702 8.27218 14.9264 8.35701 14.9641 8.4504C15.0018 8.54379 15.0203 8.64382 15.0185 8.74452C15.0168 8.84523 14.9947 8.94454 14.9537 9.03654C14.9127 9.12854 14.8536 9.21134 14.78 9.28L10.53 13.53C10.3893 13.6705 10.1987 13.7493 9.99995 13.7493C9.8012 13.7493 9.61058 13.6705 9.46995 13.53L5.21995 9.28C5.0795 9.13938 5.00061 8.94875 5.00061 8.75C5.00061 8.55125 5.0795 8.36063 5.21995 8.22Z" />
        </svg>
      </button>
    </div>
  </div>
  <div id="st-mobile-participant-category-selector-block-18" class="w-100 selector-cell" *ngIf="shouldShowCategoryDropdown">
    <div id="st-mobile-participant-category-selector-st-login-dropdown-19" class="st-selector-dropdown second">
      <button type="button" class="d-flex align-items-center gap-2 selector-trigger mobile-selector-trigger"
        (click)="openDrawer('category')">
        <span class="selector-trigger-text">{{ categoryTriggerLabel }}</span>
        <svg class="selector-trigger-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
          viewBox="0 0 20 20" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.21995 8.22C5.36058 8.07955 5.5512 8.00066 5.74995 8.00066C5.9487 8.00066 6.13933 8.07955 6.27995 8.22L9.99995 11.94L13.72 8.22C13.7886 8.14631 13.8714 8.08721 13.9634 8.04622C14.0554 8.00523 14.1547 7.98319 14.2554 7.98141C14.3561 7.97963 14.4562 7.99816 14.5495 8.03588C14.6429 8.0736 14.7278 8.12974 14.799 8.20096C14.8702 8.27218 14.9264 8.35701 14.9641 8.4504C15.0018 8.54379 15.0203 8.64382 15.0185 8.74452C15.0168 8.84523 14.9947 8.94454 14.9537 9.03654C14.9127 9.12854 14.8536 9.21134 14.78 9.28L10.53 13.53C10.3893 13.6705 10.1987 13.7493 9.99995 13.7493C9.8012 13.7493 9.61058 13.6705 9.46995 13.53L5.21995 9.28C5.0795 9.13938 5.00061 8.94875 5.00061 8.75C5.00061 8.55125 5.0795 8.36063 5.21995 8.22Z" />
        </svg>
      </button>
    </div>
  </div>
  <div id="st-mobile-participant-category-selector-block-20" class="w-100 selector-cell"
    *ngIf="internalShowSubCategories && hasSubCategoryOptions">
    <div id="st-mobile-participant-category-selector-st-login-dropdown-21"
      class="st-selector-dropdown sub-category stage-dropdown">
      <button type="button" class="d-flex align-items-center gap-2 selector-trigger mobile-selector-trigger"
        (click)="openDrawer('subCategory')">
        <span class="selector-trigger-text">{{ subCategoryTriggerLabel }}</span>
        <svg class="selector-trigger-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
          viewBox="0 0 20 20" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.21995 8.22C5.36058 8.07955 5.5512 8.00066 5.74995 8.00066C5.9487 8.00066 6.13933 8.07955 6.27995 8.22L9.99995 11.94L13.72 8.22C13.7886 8.14631 13.8714 8.08721 13.9634 8.04622C14.0554 8.00523 14.1547 7.98319 14.2554 7.98141C14.3561 7.97963 14.4562 7.99816 14.5495 8.03588C14.6429 8.0736 14.7278 8.12974 14.799 8.20096C14.8702 8.27218 14.9264 8.35701 14.9641 8.4504C15.0018 8.54379 15.0203 8.64382 15.0185 8.74452C15.0168 8.84523 14.9947 8.94454 14.9537 9.03654C14.9127 9.12854 14.8536 9.21134 14.78 9.28L10.53 13.53C10.3893 13.6705 10.1987 13.7493 9.99995 13.7493C9.8012 13.7493 9.61058 13.6705 9.46995 13.53L5.21995 9.28C5.0795 9.13938 5.00061 8.94875 5.00061 8.75C5.00061 8.55125 5.0795 8.36063 5.21995 8.22Z" />
        </svg>
      </button>
    </div>
  </div>
  <div id="st-mobile-participant-category-selector-block-22" class="w-100 selector-cell" *ngIf="shouldShowStageDropdown">
    <div id="st-mobile-participant-category-selector-st-login-dropdown-23" class="st-selector-dropdown second">
      <button type="button" class="d-flex align-items-center gap-2 selector-trigger mobile-selector-trigger"
        (click)="openDrawer('stage')">
        <span class="selector-trigger-text">{{ stageTriggerLabel }}</span>
        <svg class="selector-trigger-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
          viewBox="0 0 20 20" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.21995 8.22C5.36058 8.07955 5.5512 8.00066 5.74995 8.00066C5.9487 8.00066 6.13933 8.07955 6.27995 8.22L9.99995 11.94L13.72 8.22C13.7886 8.14631 13.8714 8.08721 13.9634 8.04622C14.0554 8.00523 14.1547 7.98319 14.2554 7.98141C14.3561 7.97963 14.4562 7.99816 14.5495 8.03588C14.6429 8.0736 14.7278 8.12974 14.799 8.20096C14.8702 8.27218 14.9264 8.35701 14.9641 8.4504C15.0018 8.54379 15.0203 8.64382 15.0185 8.74452C15.0168 8.84523 14.9947 8.94454 14.9537 9.03654C14.9127 9.12854 14.8536 9.21134 14.78 9.28L10.53 13.53C10.3893 13.6705 10.1987 13.7493 9.99995 13.7493C9.8012 13.7493 9.61058 13.6705 9.46995 13.53L5.21995 9.28C5.0795 9.13938 5.00061 8.94875 5.00061 8.75C5.00061 8.55125 5.0795 8.36063 5.21995 8.22Z" />
        </svg>
      </button>
    </div>
  </div>
  </div>
  }

  <stupa-mobile-drawer [show_mobile_drawer]="showSelectorDrawer" (close_mobile_drawer)="closeDrawerWithoutApply()">
    <p class="f_14 f_600 text-capitalize" header>{{ drawerTitle }}</p>
    <div content class="drawer-options-list">
      @if (drawerMode === 'participant') {
      @for (option of displayParticipantList; track option ? option.id : $index) {
      <label class="drawer-option-row" [class.drawer-option-row--selected]="isPendingSelected(option?.id)">
        <input type="radio" [checked]="isPendingSelected(option?.id)" (change)="selectPending(option?.id)"
          aria-label="participant-option" />
        <span>{{ (option?.title || '') | translate }}</span>
      </label>
      }
      } @else if (drawerMode === 'category') {
      @for (option of displayCategoryList; track option ? (option.video_type || option.category_id) : $index) {
      <label class="drawer-option-row"
        [class.drawer-option-row--selected]="isPendingSelected(option?.video_type || option?.category_id)">
        <input type="radio" [checked]="isPendingSelected(option?.video_type || option?.category_id)"
          (change)="selectPending(option?.video_type || option?.category_id)" aria-label="category-option" />
        <span>{{ option | categoryDisplayLabel }}</span>
      </label>
      }
      } @else if (drawerMode === 'subCategory') {
      @for (option of internalSubCategories; track option ? (option.video_type || option.category_id) : $index) {
      <label class="drawer-option-row"
        [class.drawer-option-row--selected]="isPendingSelected(option?.video_type || option?.category_id)">
        <input type="radio" [checked]="isPendingSelected(option?.video_type || option?.category_id)"
          (change)="selectPending(option?.video_type || option?.category_id)" aria-label="sub-category-option" />
        <span>{{ option | categoryDisplayLabel }}</span>
      </label>
      }
      } @else {
      @for (option of stage_list; track option ? option : $index) {
      <label class="drawer-option-row" [class.drawer-option-row--selected]="isPendingSelected(option)">
        <input type="radio" [checked]="isPendingSelected(option)" (change)="selectPending(option)"
          aria-label="stage-option" />
        <span>{{ getLocalizedStageName(option?.name) }}</span>
      </label>
      }
      }
    </div>
    <div id="st-mobile-participant-category-selector-drawer-footer-actions" footer class="drawer-footer-actions">
      <div id="st-mobile-participant-category-selector-block-24" class="d-flex justify-content-end">
        <button type="button" class="drawer-apply-btn" (click)="applyDrawerSelection()">
          {{ 'apply' | translate }}
        </button>
      </div>
    </div>
  </stupa-mobile-drawer>